import { z } from 'zod'

export const UploadExpenseFormSchema = z.object({
  files: z.array(z.instanceof(File).refine(value => value instanceof File, {
    message: 'expense.upload.form.file.error.invalid'
  })).min(1).max(3),
  description: z.string().optional(),
  receivedAt: z.string(),
})
